import {useMemo, useState} from "react";
import {
  formatMoscowDate,
  getMaxBookingDate,
  getMinBookingDate,
  getMaxViewDate,
  isSameDay,
  startOfDay,
} from "@chayka/utils";
import {Calendar as UiCalendar, YStack, Button} from "@chayka/ui";
import type {ScheduleViewProps} from "./types";
import {BookingCard} from "@/components";
import {useNavigate} from "react-router-dom";

export const Calendar: React.FC<ScheduleViewProps> = ({data}) => {
  const [date, setDate] = useState<Date>(getMinBookingDate());

  const shownBookings = useMemo(() => {
    return data?.filter((booking) => isSameDay(new Date(booking.date), date)) ?? [];
  }, [data, date]);

  const navigate = useNavigate();

  const handleBookButtonClick = () => {
    navigate(`/app/booking?date=${formatMoscowDate(date)}`);
  };

  return (
    <YStack className="gap-4">
      <UiCalendar
        minDate={getMinBookingDate()}
        maxDate={getMaxViewDate()}
        onChange={(nextDate) => setDate(startOfDay(nextDate))}
        highlightedDates={data?.map((r) => new Date(r.date))}
        value={date}
      />
      {shownBookings?.map((booking) => (
        <BookingCard
          key={booking.date.toString() + booking.roomData?.id}
          booking={booking}
          withMoreButton
        />
      ))}
      {shownBookings?.length === 0 && date <= getMaxBookingDate() && (
        <Button onClick={handleBookButtonClick}>Забронировать на эту дату</Button>
      )}
    </YStack>
  );
};
